import { Fragment, useMemo } from 'react';

const BREAKPOINTS = [1440, 1280, 1024, 768, 375];

const Picture = ({ path, className, alt, imgClassName }) => {
  const maxBreakpoint = useMemo(() => Math.max(...BREAKPOINTS), []);

  const sources = useMemo(() => (
    BREAKPOINTS.map(breakpoint => (
      <Fragment key={`${path}/${breakpoint}`}>
        <source
          srcSet={`${path}/${breakpoint}.webp, ${path}/${breakpoint}@2x.webp 2x`}
          media={`(min-width: ${breakpoint}px)`}
          type="image/webp"
        />
        <source
          srcSet={`${path}/${breakpoint}.png, ${path}/${breakpoint}@2x.png 2x`}
          media={`(min-width: ${breakpoint}px)`}
          type="image/png"
        />
      </Fragment>
    ))
  ), [path]);

  return (
    <picture className={className}>
      {sources}
      <img src={`${path}/${maxBreakpoint}.png`} alt={alt} className={imgClassName} />
    </picture>
  );
};

export default Picture;
